var render = function render(_c,_vm){return _c('div',{class:['Loader', _vm.props.theme, _vm.data.class, _vm.data.staticClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }